import '|/../sass/app.scss';
import '|/app.styl';

// Scripts
import Admin from './Admin';
import Countdown from './Countdown';
import IntoView from './IntoView';
import MatchHeight from './MatchHeight';
import OffsetHeight from './OffsetHeight';
import SmoothScroll from './SmoothScroll';
import Dismiss from './Dismiss';
import Overflow from './Overflow';
import ViewBoxSvg from './ViewBoxSvg';
import FocalPrecision from './FocalPrecision';

// Vendors
import Hamburger from './Vendor/Hamburger';
import Map from './Vendor/Google/Map';
import Parallax from './Vendor/Parallax';
import SlickSlider from './Vendor/SlickSlider';
import Sticky from './Vendor/Sticky';
import Bootstrap from './Vendor/Bootstrap';
import Masonry from './Vendor/Masonry';
import WooCommerce from './Vendor/WooCommerce';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Initialize our maps
        $('.google-map.block .map').each(function (e) {

            // Mapify that bad boy
            new Map($(this));

        });

        // Add open class to filter bar
        // Get a reference to the filter bar element
        const filterBar = document.querySelector('.post-filter-bar');

        // State variable to track open/closed state
        let isFilterBarOpen = false;

        // Function to toggle the filter bar and update state
        const toggleFilterBar = () => {
            isFilterBarOpen = !isFilterBarOpen;
            filterBar.classList.toggle('filter-bar-open');
        };

        // Example usage: Assuming a button toggles the filter bar
        const toggleButton = document.querySelector('.filter-bar-toggle');

        // Add the listener if the element exists
        if (!!toggleButton)
            toggleButton.addEventListener('click', toggleFilterBar);

        // Run our utility scripts
        new Admin();
        new Countdown();
        new IntoView();
        new SmoothScroll();
        new MatchHeight();
        new OffsetHeight();
        new Dismiss();
        new Overflow();
        new ViewBoxSvg();
        new FocalPrecision();

        // Run our vendor scripts
        new Hamburger();
        new Parallax();
        new SlickSlider();
        new Sticky();
        new Bootstrap();
        new Masonry();
        new WooCommerce();

    });

})(jQuery);